module.exports = __webpack_public_path__ + "img/878787_4C4C4C_646464_5C5C5C-256px.46f8d12f.png";